module.exports = __webpack_public_path__ + "media/images/file-icons/256/006-record-002f182ba6c405e41117fd0833367ab2.png";